module.exports = __webpack_public_path__ + "media/images/icons/monitoringZivotnihoProstredi-eab64a29baac3127d1a5ea595f3f24a4.svg";